import { GlobalWorkerOptions } from "pdfjs-dist";
import pdfjsWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Sage UI fonts — adaptive weight-based font-face declarations
import "./assets/fonts/sage_fonts.css";

// Initialize i18n before rendering the app (side-effect import)
import "./i18n/i18n";
import App from "./App";

// Override the pdfjs worker URL — this runs after all module evaluations
// (including the shared-ui library), so it correctly overrides the library's
// potentially broken `new URL(..., import.meta.url)` worker setup.
GlobalWorkerOptions.workerSrc = pdfjsWorkerUrl;

const root = createRoot(document.getElementById("root")!);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
